import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../shared/utility';

const initialState = {
  error: null,
  loading: false,
  email: null,
  emailSent: false,
};

const signUpOTPStart = (state) => (
  updateObject(state, {
    error: null,
    loading: true,
    email: null,
    emailSent: false,
  })
);

const signUpOTPSuccess = (state, action) => (
  updateObject(state, {
    error: action.error,
    loading: false,
    email: action.email,
    emailSent: true,
  })
);

const signUpOTPFail = (state, action) => (
  updateObject(state, {
    error: action.error,
    loading: false,
  })
);

const reducer = (state = initialState, action = null) => {
  switch (action.type) {
    case actionTypes.SIGN_UP_OTP_START:
      return signUpOTPStart(state);
    case actionTypes.SIGN_UP_OTP_SUCCESS:
      return signUpOTPSuccess(state, action);
    case actionTypes.SIGN_UP_OTP_FAIL:
      return signUpOTPFail(state, action);
    case actionTypes.SIGN_UP_OTP_RESET:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
